import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { PrimaryButton, SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';

interface DeleteModalProps {
  isOpen: boolean;
  familyMemberName: string;
  onClose: () => void;
  onSubmit: () => void;
}

const ConfirmDeleteFamilyMember: FC<DeleteModalProps> = ({
  isOpen,
  familyMemberName,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <Modal open={isOpen}>
      <StyledModal>
        <CloseIcon onClick={onClose} />
        <h1>
          {t('family_members.confirmDelete')} <span>{familyMemberName}</span>?
        </h1>
        <section>
          <SecondaryButton onClick={onClose}>{t('cancel')}</SecondaryButton>
          <PrimaryButton onClick={onSubmit} styleType={'error'}>
            {t('appointment_types.delete_type.confirm')}
          </PrimaryButton>
        </section>
      </StyledModal>
    </Modal>
  );
};

export default ConfirmDeleteFamilyMember;
